import * as accountService from "@/services/account";
import { eventTracker } from "@/utils/eventTracker"
import analyticsEvents from "@/utils/analyticsEvents"

export const actions = {
  signIn: async ({}, payload) => {
    const { data } = await accountService.signIn(payload);
    return data;
  },
  acceptInvitationByToken: async ({ state }, payload) => {
    const { data } = await accountService.acceptInvitationByToken(state.inviteToken);
    return data;
  },
  setInviteToken: ({ dispatch, commit }, payload) => {
    const { token } = payload;
    commit("TEAM_INVITATION_SET_INVITE_TOKEN", token);
    dispatch("getMembershipFromToken", payload);
  },
  setInviteTokenAndRedirect: ({ dispatch, commit }, payload) => {
    const { token } = payload;
    commit("TEAM_INVITATION_SET_INVITE_TOKEN", token);
    dispatch("getMembershipFromTokenAndRedirect", payload);
  },
  getMembershipFromToken: async ({ commit }, payload) => {
    try {
      const { token } = payload
      const { data } = await accountService.getMembershipFromToken(token);
      const member = data.data;
      commit("TEAM_INVITATION_SET_INVITE_MEMBER", member);
    } catch (err) {}
  },
  getMembershipFromTokenAndRedirect: async ({ dispatch, commit }, payload) => {
    try {
      const { token, router } = payload;
      const { data } = await accountService.getMembershipFromToken(token);
      const member = data.data;
      commit("TEAM_INVITATION_SET_INVITE_MEMBER", member);
      dispatch("redirectByMembership", {
        member,
        router
      });
    } catch (err) {
      commit("TEAM_INVITATION_SET_ERROR", true);
    }
  },
  redirectByMembership: ({ state, rootState }, payload) => {
    const { member, router } = payload;
    const { user } = rootState;

    let path = "create-account";

    if (member.user_exists) {
      path =
      user && user.email === member.email ? "respond" : "log-in";
    }

    if (router) {
      router.replace({
        path: `/team-invite/${state.inviteToken}/${path}/`,
      });
    } else {
      window.location.replace(`/team-invite/${state.inviteToken}/${path}/`)
    }
  },
  createFromTeamInviteToken: async ({ state, commit }, payload) => {
    try {
      commit("TEAM_INVITATION_SET_ERROR", null);
      commit("TEAM_INVITATION_SET_LOADING", { inviteMember: true });

      eventTracker(analyticsEvents.clickCreateAccount);
      const { data } = await accountService.createFromTeamInviteToken(
        state.inviteToken,
        payload
      );
      const member = data.data;

      commit("TEAM_INVITATION_SET_INVITE_MEMBER", member);
      window.location.href = "/sign-up/thank-you/paid/";
    } catch (err) {
      commit("TEAM_INVITATION_SET_LOADING", { inviteMember: false });
      commit("TEAM_INVITATION_SET_ERROR", { ...err.response.data });
    }
  },
  clearError: async ({ commit }) => {
    commit("TEAM_INVITATION_SET_ERROR", null);
  },
};
